import { render } from "./Main.vue?vue&type=template&id=3d89ce34"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__